<template>
  <!-- 后台访问日志 -->
  <div class="page">
    <!-- 搜索区域 -->
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="auto" class="from">
        <!-- 操作日期 -->
        <el-form-item :label="$t('pages.system.text60')">
          <el-date-picker
            v-model="startAt"
            type="datetime"
            :placeholder="$t('public.text2')"
            @change="startChange"
            :picker-options="pickerOptions0"
          >
          </el-date-picker>
          <span style="margin: 0 8px">-</span>
          <el-date-picker
            v-model="stopAt"
            type="datetime"
            :placeholder="$t('public.text3')"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <!-- 日志类别 -->
        <el-form-item :label="$t('pages.system.text55')">
          <el-select
            v-model="searchParams.apiName"
            clearable
            :placeholder="$t('pages.system.text55')"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 平台方 -->
        <el-form-item :label="$t('menu.platform')">
          <el-select
            v-model="searchParams.belongCustomer"
            clearable
            :placeholder="$t('pages.research.text89')"
          >
            <el-option
              v-for="(item, index) in option"
              :key="index"
              :label="item.platformShortName"
              :value="item.id + ''"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 操作人 -->
        <el-form-item :label="$t('pages.research.text14')">
          <el-input
            v-model="searchParams.userName"
            :placeholder="$t('public.text1')"
          ></el-input>
        </el-form-item>
        <el-form-item label="参数内容">
          <el-input
            v-model="searchParams.contentLike"
            :placeholder="$t('public.text1')"
          ></el-input>
        </el-form-item>
      </el-form>
      <!-- 按钮区域 -->
      <div class="searchSubmit">
        <DiluButton
          type="search"
          @click="search"
          v-permission="['logList:query']"
        ></DiluButton>
        <DiluButton
          type="reset"
          @click="reset"
          v-permission="['logList:reset']"
        ></DiluButton>
      </div>
    </div>
    <!-- 表格 -->
    <DiluTable
      :list="tableData"
      :tableConfig="tableConfig"
      :pageSize="searchParams.pageSize"
      :total="total"
      @currentChange="currentChange"
    >
      <el-table-column prop="date" label="#" width="80" align="center">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <!-- 操作人账号 -->
      <el-table-column
        prop="userName"
        :label="$t('pages.research.text15')"
        width="180"
        align="center"
      >
      </el-table-column>
      <!-- 日志类别 -->
      <el-table-column
        prop="apiName"
        :label="$t('pages.research.text12')"
        width="180"
        align="center"
      >
      </el-table-column>
      <!-- 操作内容 -->
      <el-table-column
        prop="apiInfo"
        :label="$t('pages.research.text9')"
        align="center"
      >
      </el-table-column>
      <!-- IP -->
      <el-table-column prop="requestIp" label="IP" width="180" align="center">
      </el-table-column>
      <!-- 操作日期 -->
      <el-table-column
        prop="createdAt"
        :label="$t('pages.research.text11')"
        align="center"
      >
      </el-table-column>
    </DiluTable>
  </div>
</template>

<script>
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import DiluTable from "../../../components/pubilc/dilu-table.vue";
import { resetDate } from "../../../utils/util/validate";
export default {
  data() {
    return {
      pickerOptions0: {
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));

              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      //选中的开始日期之前的日期禁选
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < this.startAt;
        },
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));

              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      searchParams: {
        belongCustomer: "", // 归属客户
        apiName: "", // 日志类别
        compare: "", // 比较条件
        createdAt: "", // 操作日期
        duration: "", // 执行时长
        pageNum: 1, // 页码
        pageSize: 10, // 每页条数
        userName: "", // 操作人
        contentLike: "",
        requestUrl: "", // 请求地址
      },
      startAt: "", //开始日期
      stopAt: "", //结束日期
      total: 0,
      option: [],
      options: [
        {
          value: "login",
          label: this.$t("pages.login.text7"), //登录
        },
        {
          value: "logout",
          label: this.$t("pages.system.text58"), //登出
        },
        {
          value: "add",
          label: this.$t("button.add"), //新增
        },
        {
          value: "delete",
          label: this.$t("button.delete"), //删除
        },
        {
          value: "edit",
          label: this.$t("button.edit"), //编辑
        },
        {
          value: "query",
          label: this.$t("button.query"), //查询
        },
        {
          value: "import",
          label: this.$t("button.import"), //导入
        },
        {
          value: "export",
          label: this.$t("button.export"), //导出
        },
        {
          value: "review",
          label: this.$t("button.examine"), //审核
        },
        {
          value: "bind",
          label: this.$t("pages.equipment.text42"), //绑定
        },
        {
          value: "unbind",
          label: this.$t("pages.equipment.text43"), //解绑
        },
        {
          value: "other",
          label: this.$t("pages.research.text88"), //其他
        },
      ],
      value: "",
      tableConfig: {
        isTree: false,
        isPage: true, //打开分页功能
      },
      tableData: [],
    };
  },
  components: {
    DiluTable,
    DiluButton,
  },
  mounted() {
    this.stopAt = resetDate(new Date()); // 当前时间
    this.startAt = this.fun_date(-7); //七天前的时间
    this.admList();
    this.platformListAll();
  },
  methods: {
    //搜索
    search() {
      this.searchParams.pageNum = 1;
      this.total = 0;
      this.admList();
    },
    //更改开始日期时间时结束日期时间置空重选
    startChange() {
      this.stopAt = "";
    },
    //平台方-查询所有
    platformListAll() {
      this.request.platformListAll().then((res) => {
        this.option = res.data;
      });
    },
    // 翻页
    currentChange(e) {
      this.searchParams.pageNum = e;
      this.admList();
    },
    // 重置
    reset() {
      this.searchParams = {
        belongCustomer: "", // 归属客户
        apiName: "", // 日志类别
        compare: "", // 比较条件
        createdAt: [], // 操作日期
        duration: "", // 执行时长
        pageNum: 1, // 页码
        pageSize: 10, // 每页条数
        realName: "", // 操作人
        contentLike: "",
        requestUrl: "", // 请求地址
      };
      this.total = 0;
      this.startAt = ""; //开始日期
      this.stopAt = ""; //结束日期
      this.admList();
    },
    formatTen(num) {
      return num > 9 ? num + "" : "0" + num;
    },
    // 获取当前时间
    fun_date(aa) {
      var date1 = new Date();
      var date2 = new Date(date1);
      var hour = date2.getHours();
      var minute = date2.getMinutes();
      var second = date2.getSeconds();
      // 获取当前时间前后aa天时间
      date2.setDate(date1.getDate() + aa);
      var time2 =
        date2.getFullYear() +
        "-" +
        (date2.getMonth() + 1) +
        "-" +
        date2.getDate() +
        " " +
        this.formatTen(hour) +
        ":" +
        this.formatTen(minute) +
        ":" +
        this.formatTen(second);
      return time2;
    },
    // 获取日志列表
    admList() {
      if (this.stopAt && this.startAt) {
        this.stopAt = resetDate(this.stopAt); // 结束时间
        this.startAt = resetDate(this.startAt); // 开始时间
        this.searchParams.createdAt = [this.startAt, this.stopAt];
      } else {
        this.searchParams.createdAt = [];
      }
      if (this.startAt) {
        if (!this.stopAt) {
          return this.$message.error(this.$t("public.text3")); //请选择结束日期
        }
      }
      if (this.stopAt) {
        if (!this.startAt) {
          return this.$message.error(this.$t("public.text2")); //请选择开始日期
        }
      }
      this.request.admList(this.searchParams).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.dataMaxCount;
      });
    },
  },
};
</script>

<style scoped>
.page {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.from {
  float: left;
  display: flex;
}
.searchSubmit {
  float: right;
  display: flex;
}
.operation {
  margin-bottom: 20px;
  display: flex;
}
</style>